<template>
  <div class="box" v-loading="loading">
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <div class="card_wrap">
      <div class="card">
        <div class="status">
          <status-card
            :dataArr="statusArr"
            labelWidth="0px"
            :title="language('productsRecord.queryStatus')"
            @change="changeStatus"
          ></status-card>
        </div>
        <div class="ymd">
          <ymd-card-v2
            :title="language('productsRecord.period')"
            @change="changeTime"
            startTime="startTime"
            endTime="endTime"
            select="timeType"
            :options="timeOptios"
          ></ymd-card-v2>
        </div>
        <div class="input">
          <input-card
            :title="language('productsRecord.transaction')"
            :dataArr="inputArr"
            labelPosition="top"
            @change="changeInput"
          ></input-card>
        </div>
        <!-- <div class="shop_input">
          <input-card
            :title="language('SettlementReport.transaction')"
            :dataArr="shopInputArr"
            labelPosition="top"
            @change="changeShopInput"
          ></input-card>
        </div> -->
      </div>
      <div class="tips">{{ language("productsRecord.searchTips") }}</div>
      <div class="button_wrap">
        <el-button type="primary" @click="search">{{
          language("productsRecord.search")
        }}</el-button>
      </div>
    </div>

    <div class="table_wrap">
      <div class="count_box">
        <div class="count">
          {{ language("orderRecord.results") }}: {{ results }}
          {{ language("orderRecord.rows") }}
          <template v-if="dataArr.length > 0">
            <el-button
              type="primary"
              @click="
                $utils.download2(
                  '/admin/merchant/report/exportProductsRecord',
                  form5
                )
              "
              >{{ language("all.download") }}</el-button
            >
          </template>
        </div>
        <div class="page_wrap">
          <page :total="results" @pageChange="pageChange" ref="page"></page>
        </div>
      </div>

      <cc-table
        :loadData="false"
        :config="table"
        :params="params"
        :refeshParams="refeshTable"
        :dataArr="dataArr"
        :emptyText="language('productsRecord.emptyText')"
        :showIndex="false"
      ></cc-table>
    </div>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import statusCard from "../../components/statusCard";
import ymdCardV2 from "../../components/ymdCardV2";
import inputCard from "../../components/inputCard";
import page from "../../components/page";

export default {
  components: {
    breadcrumb,
    statusCard,
    ymdCardV2,
    inputCard,
    page,
  },
  data() {
    return {
      loading: false,
      breadcrumb: {
        title: this.language("productsRecord.breadcrumbTitle"),
        list: [
          {
            name: this.language("productsRecord.breadcrumbList_1"),
          },
          {
            name: this.language("productsRecord.breadcrumbList_2"),
          },
        ],
      },
      statusArr: [
        {
          title: "",
          checkbox: [],
          list: [
            {
              name: "Delivered",
              apiName: "transactionStatus",
              value: "1",
            },
            {
              name: "Refunded",
              apiName: "transactionStatus",
              value: "4",
            },
            {
              name: "Cancel",
              apiName: "transactionStatus",
              value: "2",
            },
            {
              name: "On Hold",
              apiName: "transactionStatus",
              value: "0",
            },
            {
              name: "CSCancel",
              apiName: "transactionStatus",
              value: "3",
            },
          ],
        },
      ],
      timeOptios: [
        { label: "Delivered Date", value: "Delivered Date" },
        { label: "Order Create Date", value: "Order Create Date" },
      ],
      inputArr: [
        {
          name: "Order ID",
          apiName: "orderId",
          value: "",
        },
        {
          name: "Promotion ID",
          apiName: "promotionId",
          value: "",
        },
      ],
      shopInputArr: [
        {
          name: "Merhant ID",
          apiName: "MerhantIDID",
          value: "",
          type: "select",
          options: [],
        },
      ],
      params: {},
      refeshTable: -1,
      table: {
        api: "",
        showPager: false,
        columns: [
          {
            prop: "mchNum",
            lable: "Master A/C",
            minWidth: 130,
          },
          {
            prop: "mchShopNum",
            minWidth: 130,
            lable: "Merhant ID",
          },
          {
            prop: "masterOrderId",
            lable: "Master Order ID",
            minWidth: 150,
          },
          {
            prop: "orderId",
            lable: "Order ID",
            minWidth: 180,
          },
          {
            prop: "wbNum",
            lable: "Waybill No.",
            minWidth: 135,
          },
          {
            prop: "orderStatusName",
            lable: "Order Status",
            minWidth: 140,
          },
          {
            prop: "transactionStatusName",
            lable: "Transaction Status",
            minWidth: 140,
          },
          {
            prop: "orderTime",
            lable: "Order Create Date",
            minWidth: 200,
          },
          {
            prop: "updateTime",
            lable: "Updated Date",
            minWidth: 200,
          },
          {
            prop: "deliveredDate",
            lable: "Delivered Date",
            minWidth: 200,
          },
          {
            prop: "productId",
            minWidth: 160,
            lable: "Product ID",
          },
          {
            prop: "productName",
            minWidth: 200,
            lable: "Product Name",
          },
          {
            prop: "saleNum",
            lable: "QTY",
            minWidth: 100,
          },
          {
            prop: "originalPrice",
            lable: "Original Sales Amount",
            minWidth: 100,
            render: (rows) => {
              // return this.$utils.toFixedDigit(rows.originalPrice, 2);
              return rows.originalPriceF;
            },
          },
          {
            prop: "netSaleAmount",
            lable: "Net Sales Amount",
            minWidth: 100,
            render: (rows) => {
              // return this.$utils.toFixedDigit(rows.netSaleAmount, 1);
              return rows.netSaleAmountF;
            },
          },
          {
            prop: "refundPrice",
            lable: "Refund Amount",
            minWidth: 100,
            render: (rows) => {
              // return this.$utils.toFixedDigit(rows.refundPrice, 1);
              return rows.refundPriceF;
            },
          },
          {
            prop: "actualPrice",
            lable: "Actual Sales",
            minWidth: 100,
            render: (rows) => {
              // return this.$utils.toFixedDigit(rows.actualPrice, 1);
              return rows.actualPriceF;
            },
          },
          {
            prop: "promotionId",
            lable: "Promotion ID",
            minWidth: 230,
          },
          {
            prop: "promotionName",
            lable: "Promotion Name",
            minWidth: 230,
          },
          {
            prop: "promotionType",
            lable: "Promotion Type",
            minWidth: 180,
            render: (rows) => {
              let type = {
                flashSale: "BasicDiscounts",
                buyMoreGetMore: "BuyMoreGetMore",
                MChooseN: "FixedPriceInQty",
              };
              if (type[rows.promotionType]) {
                return type[rows.promotionType];
              } else {
                return rows.promotionType;
              }
            },
          },
        ],
        buttons: [],
      },
      dataArr: [],
      results: 0,
      form1: {},
      form2: {},
      form3: {},
      form4: {},
      form5:{},
      form: {
        pageSize: 10,
        pageNo: 1,
      },
      shopData: {},
    };
  },
  methods: {
    changeStatus(e) {
      this.form1 = { ...e };
      this.svaeForm(this.form1, this.form2, this.form3);
    },
    changeTime(e) {
      if (e.timeType == "Order Create Date") {
        this.form2 = {
          geOrderTime: e.startTime,
          leOrderTime: e.endTime,
        };
      } else {
        this.form2 = {
          geDeliveredDate: e.startTime,
          leDeliveredDate: e.endTime,
        };
      }
      this.svaeForm(this.form1, this.form2, this.form3);
    },
    changeInput(e) {
      console.log(e);
      this.form3 = { ...e };
      this.svaeForm(this.form1, this.form2, this.form3);
    },
    changeShopInput(e) {
      console.log(e);
    },
    svaeForm(form1, form2, form3, form4) {
      this.form = {
        ...form1,
        ...form2,
        ...form3,
        ...form4,
        pageSize: this.form.pageSize,
        pageNo: this.form.pageNo,
        shopNum: this.shopData.shopNum,
        mchShopNum: this.shopData.shopNum,
      };
    },
    pageChange(e) {
      this.form.pageSize = e.pageSize;
      this.form.pageNo = e.pageNo;
      this.getData(this.form);
    },
    search() {
      this.form.pageSize = 10;
      this.form.pageNo = 1;
      this.$refs.page.init();
      console.log(this.form);
      this.getData(this.form);
    },
    getData(e) {
      this.loading = true;
      e.shopNum = this.shopData.shopNum;
      e.mchShopNum = this.shopData.shopNum;
      // this.form.shopNum = this.shopData.shopNum;
      // this.form.mchShopNum = this.shopData.shopNum;
      this.form5=e
      this.ccRequest
        // .do("admin/merchant/report/getOrderRecord", e) 廢棄
        .do("admin/merchant/report/getProductsRecord", e)
        .then((res) => {
          this.dataArr = res.rows;
          this.results = res.total;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    let shopData = this.$shopData;
    this.shopData = shopData;
    this.getData({
      pageSize: 10,
      pageNo: 1,
    });
  },
};
</script>
<style scoped lang="scss">
.box {
  height: 100%;
}
.card_wrap {
  background: #f7f7f7;
  padding: 20px;
  h5 {
    font-size: $title;
    margin: 10px 0 20px 0;
  }
  .card {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    .status {
      flex: 1;
    }
    .ymd {
      padding-right: 20px;
      padding-left: 20px;
      flex: 1;
    }
    .input {
      width: 300px;
      flex: 1;
    }
    .shop_input {
      margin-left: 20px;
      flex: 1;
    }
  }
}
.tips {
  margin-top: 10px;
  font-size: $sbuTitle;
}
.button_wrap {
  margin-top: 20px;
}
.table_wrap {
  margin-top: 50px;
  .count {
    font-size: $sbuTitle;
    font-weight: 600;
  }
  .count_box {
    margin-bottom: 20px;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.button_wrap {
  margin-bottom: 20px;
}
</style>